import { TableOption, TableOptions } from 'Design/components/Table'

const GuideOptions = (props) => {
  const { onDeleteClick } = props

  return (
    <TableOptions>
      <TableOption onClick={onDeleteClick}>Delete</TableOption>
    </TableOptions>
  )
}

export default GuideOptions
